import { __ } from "@wordpress/i18n";
import { ReactComponent as Logo } from "../assets/header_logo.svg";
import SocialWallLinks from "./SocialWallLinks";

const SettingsHeader = ({ title }) => {
  return (
    <div className="sby-fb-header sby-fb-fs">
      <div className="sby-fb-header-left">
        <div className="sby-fb-hd-logo">
          <Logo />
          <span className="breadcrumb-title">/ {title}</span>
        </div>
        <SocialWallLinks />
      </div>
      <div className="sby-fb-header-right">
        <a
          className="sby-fb-hd-btn sb-btn-grey sb-button-standard"
          data-icon="left"
          href={window.sby_settings.supportPageUrl}
        >
          <svg
            className="sb"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.16797 14.0001H9.83464V12.3334H8.16797V14.0001ZM9.0013 0.666748C4.4013 0.666748 0.667969 4.40008 0.667969 9.00008C0.667969 13.6001 4.4013 17.3334 9.0013 17.3334C13.6013 17.3334 17.3346 13.6001 17.3346 9.00008C17.3346 4.40008 13.6013 0.666748 9.0013 0.666748ZM9.0013 15.6667C5.3263 15.6667 2.33464 12.6751 2.33464 9.00008C2.33464 5.32508 5.3263 2.33341 9.0013 2.33341C12.6763 2.33341 15.668 5.32508 15.668 9.00008C15.668 12.6751 12.6763 15.6667 9.0013 15.6667ZM9.0013 4.00008C7.15964 4.00008 5.66797 5.49175 5.66797 7.33342H7.33464C7.33464 6.41675 8.08464 5.66675 9.0013 5.66675C9.91797 5.66675 10.668 6.41675 10.668 7.33342C10.668 9.00008 8.16797 8.79175 8.16797 11.5001H9.83464C9.83464 9.62508 12.3346 9.41675 12.3346 7.33342C12.3346 5.49175 10.843 4.00008 9.0013 4.00008Z"
              fill="#141B38"
            />
          </svg>
          <span>{__("Help", "feeds-for-youtube")}</span>
        </a>
      </div>
    </div>
  );
};

export default SettingsHeader;
